<template>
  <!-- 新增考试弹窗 -->
  <div v-if="visible" class="dialog-overlay" @click="handleClose">
    <div class="dialog-content" @click.stop>
      <div class="dialog-header">
        <h3>新增考试</h3>
        <button class="close-btn" @click="handleClose">×</button>
      </div>
      <div class="dialog-body">
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label>考试名称</label>
            <input
              type="text"
              v-model="formData.testName"
              placeholder="请输入考试名称，如：剑18 Test1 | 2023年12月第一套"
              required
            />
          </div>
          <div class="form-group">
            <label>年份</label>
            <input
              type="number"
              v-model="formData.testOrder"
              placeholder="请输入年份，如：剑18填写18 | 2023年填写2023"
              required
            />
          </div>
          <div class="form-group">
            <label>考试次序</label>
            <input
              type="number"
              v-model="formData.testIndex"
              placeholder="请输入考试次序，如：第一套 填写1 | Test1 填写 "
              required
            />
          </div>
          <div class="form-group">
            <label>考试类型</label>
            <select v-model="formData.testType" required>
              <option
                v-for="exam in examTypes"
                :key="exam.value"
                :value="exam.value"
              >
                {{ exam.label }}
              </option>
            </select>
          </div>
        </form>
      </div>
      <div class="dialog-footer">
        <button type="button" class="cancel-btn" @click="handleClose">
          取消
        </button>
        <button type="button" class="confirm-btn" @click="handleSubmit">
          确认
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddTestDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    examTypes: {
      type: Array,
      default: () => [],
    },
    defaultTestType: {
      type: [Number],
      default: 1,
    },
  },
  data() {
    return {
      formData: {
        testName: "",
        testOrder: "",
        testIndex: "",
        testType: "",
      },
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetForm();
        // 确保弹窗打开时设置正确的默认值
        this.$nextTick(() => {
          this.formData.testType =
            this.defaultTestType !== undefined ? this.defaultTestType : "";
        });
      }
    },
    defaultTestType: {
      handler(newVal) {
        if (this.visible) {
          this.formData.testType = newVal !== undefined ? newVal : "";
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    resetForm() {
      this.formData = {
        testName: "",
        testOrder: "",
        testIndex: "",
        testType:
          this.defaultTestType !== undefined ? this.defaultTestType : "",
      };
    },
    handleSubmit() {
      console.log(this.formData);
      // 验证表单
      if (
        !this.formData.testName ||
        !this.formData.testOrder ||
        !this.formData.testIndex
      ) {
        this.$message.error(`请填写完所有字段`);
        return;
      }

      // 发送数据到父组件
      this.$emit("submit", { ...this.formData });
    },
  },
};
</script>

<style scoped>
/* 弹窗样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-content {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  background: linear-gradient(135deg, #ffd700 0%, #ffed4a 100%);
  border-radius: 12px 12px 0 0;
}

.dialog-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  font-weight: bold;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.1);
  color: #333;
}

.dialog-body {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #ffd700;
  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);
}

.form-group input::placeholder {
  color: #999;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #eee;
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;
}

.cancel-btn,
.confirm-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
}

.cancel-btn {
  background: #f5f5f5;
  color: #666;
}

.cancel-btn:hover {
  background: #e8e8e8;
}

.confirm-btn {
  background: #ffd700;
  color: #2c3e50;
}

.confirm-btn:hover {
  background: #e6c200;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .dialog-content {
    width: 95%;
    margin: 20px;
  }

  .dialog-header,
  .dialog-body,
  .dialog-footer {
    padding: 16px;
  }

  .dialog-footer {
    flex-direction: column;
  }

  .cancel-btn,
  .confirm-btn {
    width: 100%;
  }
}
</style>
